// extracted by mini-css-extract-plugin
export default {"ProgressBar":"project-migration-overlay-view-module__ProgressBar--EZccl"};